// @ts-nocheck
import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { resetPassword } from '../services/api';
import EyeIcon from '../components/EyeIcon';
import PrivacyNoticeLink from '../components/PrivacyNoticeLink';

const cardStyle = {
  width: '100%',
  maxWidth: 400,
  background: '#ffffff',
  border: '1px solid #dbe5f3',
  borderRadius: 14,
  padding: 28,
  boxShadow: '0 14px 36px rgba(30, 58, 95, 0.12)',
};

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState<any>('');
  const [confirmPassword, setConfirmPassword] = useState<any>('');
  const [showNewPassword, setShowNewPassword] = useState<any>(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState<any>(false);
  const [error, setError] = useState<any>('');
  const [success, setSuccess] = useState<any>('');
  const [loading, setLoading] = useState<any>(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (newPassword.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      const result = await resetPassword(token, newPassword);
      setSuccess(result.message || 'Password reset successfully. You can now sign in.');
      window.setTimeout(() => navigate('/login'), 1200);
    } catch (resetError: any) {
      setError(resetError.message || 'Could not reset password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 20, background: 'linear-gradient(135deg, #2563eb 0%, #60a5fa 100%)' }}>
      <section style={cardStyle}>
        <h1 style={{ margin: 0, color: '#1e3a5f', fontSize: 25 }}>Choose a new password</h1>
        <p style={{ color: '#64748b', fontSize: 14, lineHeight: 1.5 }}>Use at least 8 characters. Check your email for this link's expiration time.</p>
        <form onSubmit={handleSubmit}>
          <label htmlFor="new-password" style={{ display: 'block', color: '#374151', fontSize: 13, fontWeight: 700, marginBottom: 6 }}>New password</label>
          <div style={{ position: 'relative' }}>
            <input id="new-password" type={showNewPassword ? 'text' : 'password'} value={newPassword} onChange={(event) => setNewPassword(event.target.value)} required minLength={8} autoComplete="new-password" style={{ width: '100%', boxSizing: 'border-box', padding: '11px 42px 11px 12px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: 15 }} />
            <button type="button" onClick={() => setShowNewPassword((value) => !value)} aria-label={showNewPassword ? 'Hide new password' : 'Show new password'} style={visibilityButtonStyle}><EyeIcon open={showNewPassword} /></button>
          </div>
          <label htmlFor="confirm-password" style={{ display: 'block', color: '#374151', fontSize: 13, fontWeight: 700, margin: '14px 0 6px' }}>Confirm password</label>
          <div style={{ position: 'relative' }}>
            <input id="confirm-password" type={showConfirmPassword ? 'text' : 'password'} value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} required autoComplete="new-password" style={{ width: '100%', boxSizing: 'border-box', padding: '11px 42px 11px 12px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: 15 }} />
            <button type="button" onClick={() => setShowConfirmPassword((value) => !value)} aria-label={showConfirmPassword ? 'Hide confirmed password' : 'Show confirmed password'} style={visibilityButtonStyle}><EyeIcon open={showConfirmPassword} /></button>
          </div>
          {success && <div style={{ marginTop: 14, padding: 10, borderRadius: 8, color: '#166534', background: '#f0fdf4', border: '1px solid #bbf7d0', fontSize: 13 }}>{success}</div>}
          {error && <div style={{ marginTop: 14, padding: 10, borderRadius: 8, color: '#b91c1c', background: '#fef2f2', border: '1px solid #fecaca', fontSize: 13 }}>{error}</div>}
          <button type="submit" disabled={loading || Boolean(success)} style={{ width: '100%', marginTop: 18, padding: '11px 14px', border: 'none', borderRadius: 8, background: loading || success ? '#93b4ed' : '#3256a2', color: '#ffffff', fontWeight: 700, cursor: loading || success ? 'not-allowed' : 'pointer' }}>{loading ? 'Resetting...' : 'Reset password'}</button>
        </form>
        {!success && <Link to="/request-setup-link" style={{ display: 'inline-block', marginTop: 16, color: '#2563eb', fontSize: 13, fontWeight: 700 }}>
          Invitation expired? Request a new setup email
        </Link>}
        <div style={{ marginTop: 14 }}><PrivacyNoticeLink /></div>
        <Link to="/login" style={{ display: 'inline-block', marginTop: 12, color: '#2563eb', fontSize: 13, fontWeight: 700 }}><span aria-hidden="true">← </span>Back to sign in</Link>
      </section>
    </main>
  );
}

const visibilityButtonStyle = {
  position: 'absolute',
  right: 10,
  top: '50%',
  transform: 'translateY(-50%)',
  border: 'none',
  background: 'transparent',
  color: '#475569',
  cursor: 'pointer',
  padding: 0,
  lineHeight: 1,
};